<template>
<div class="chapter">
<div class="inner_page">
<p class="body_ni">First published as <em class="italic">L’An 1 de la revolution russe</em> in 1930.</p>
<p class="body_ni">Translation, Translator’s Introduction, and Notes © 1972, Peter Sedgwick.</p>
<p> </p>
<p class="body_ni">This edition published in 2015 by</p>
<p class="body_ni">Haymarket Books</p>
<p class="body_ni">P.O. Box 180165</p>
<p class="body_ni">Chicago, IL 60618</p>
<p class="body_ni">773-583-7884</p>
<p class="body_ni">info@haymarketbooks.org</p>
<p class="body_ni">www.haymarketbooks.org</p>
<p> </p>
<p class="body_ni">ISBN: 978-1-60846-609-2</p>
<p> </p>
<p class="body_ni">Trade distribution:</p>
<p class="body_ni">In the US, Consortium Book Sales and Distribution, www.cbsd.com</p>
<p class="body_ni">In the UK, Turnaround Publisher Services, www.turnaround-uk.com</p>
<p class="body_ni">In Canada, Publishers Group Canada, www.pgcbooks.ca</p>
<p class="body_ni">All other countries, Publishers Group Worldwide, www.pgw.com</p>
<p> </p>
<p class="body_ni">Cover design by Ragina Johnson.</p>
<p> </p>
<p class="body_ni">This book was published with the generous support of Lannan Foundation and the Wallace Action Fund.</p>
<p> </p>
<p class="body_ni">Library of Congress Cataloging in Publication data is available.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?591a1868